import { render, staticRenderFns } from "./RiderDispatch.vue?vue&type=template&id=34917355&scoped=true"
import script from "./RiderDispatch.vue?vue&type=script&lang=js"
export * from "./RiderDispatch.vue?vue&type=script&lang=js"
import style0 from "./RiderDispatch.vue?vue&type=style&index=0&id=34917355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34917355",
  null
  
)

export default component.exports